import { render } from "./InputNumber.vue?vue&type=template&id=6b28155f"
import script from "./InputNumber.vue?vue&type=script&lang=ts"
export * from "./InputNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script